import React from 'react';
import styles from './CarouselPagination.css';
import { getTransform } from './utils/transfrom';

interface ICarouselPaginationProps {
  count: number;
  active: number;
}

export const CarouselPagination: React.FC<ICarouselPaginationProps> = ({ count, active, children }) => (
  <div className={styles['wrapper']}>
    <ul className={styles['container']} style={getTransform(active, count)}>
      {children}
    </ul>
  </div>
);
